import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';


// eslint-disable-next-line react/prefer-stateless-function
class TasksLeftSidebar extends React.PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <h4>{t('tasks.page_title')}</h4>
        <p>{t('tasks.p1')}</p>
        <p>{t('tasks.p2')}</p>
        <p>{t('tasks.p3')}</p>
        <p>{t('tasks.p4')}</p>
        <p>{t('tasks.p5')}</p>
        <p>{t('tasks.p6')}</p>
      </div>
    );
  }
}

export default withTranslation('common')(TasksLeftSidebar);
